import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

import { SharedModule } from '../shared/shared.module';
import { CarRoutingModule } from './car-routing.module';
import { CarDetailComponent } from './car-detail/car-detail.component';
import { CarListComponent } from './car-list/car-list.component';
import { CarSpecComponent } from './car-detail/car-spec/car-spec.component';
import { CarUpperPriceComponent } from './car-detail/car-upper-price/car-upper-price.component';
import { CarLowerPriceComponent } from './car-detail/car-lower-price/car-lower-price.component';
import { CarPriceComponent } from './car-list/car-price/car-price.component';
import { CarSortComponent } from './car-list/car-sort/car-sort.component';
import { CarPaginationComponent } from './car-list/car-pagination/car-pagination.component';
import { CarVideoComponent } from './car-detail/car-video/car-video.component';
import { CarListItemComponent } from './car-list/car-list-item/car-list-item.component';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  declarations: [
    NotFoundComponent,
    CarDetailComponent,
    CarListComponent,
    CarSpecComponent,
    CarUpperPriceComponent,
    CarLowerPriceComponent,
    CarPriceComponent,
    CarSortComponent,
    CarPaginationComponent,
    CarVideoComponent,
    CarListItemComponent,
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
    SharedModule,
    CarRoutingModule,
  ],
})
export class CarModule { }
